/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link, Text, View } from '@react-pdf/renderer';
import styles from '../pro-report-pdf-styles';

interface DestinationDisclaimerProps {
  portName?: string;
  portUnlocode?: string;
  aisDestination?: string | null;
}

function DestinationDisclaimer({
  portName,
  portUnlocode,
  aisDestination,
}: DestinationDisclaimerProps) {
  if (!aisDestination) return null;

  return (
    <View style={styles.section}>
      <Text>
        {`The vessel's AIS transponder indicates a destination of `}
        <Text style={{ fontWeight: 'bold' }}>{`'${aisDestination}'`}</Text>,
        GlobeView has interpreted this to mean the port of{' '}
        <Text
          style={{ fontWeight: 'bold' }}
        >{`'${portName}' (UNLOCODE: ${portUnlocode})`}</Text>
        .
        {` If the resolved destination is incorrect, please amend the vessel's `}
        <Text style={{ fontWeight: 'bold' }}>
          AIS transponder “destination port”
        </Text>{' '}
        {`to the destination port's `}
        <Text style={{ fontWeight: 'bold' }}>{`exact "UNLOCODE"`}</Text>, In the
        meantime, you can visit{' '}
        <Link
          src="https://globeview.north-standard.com/ports"
          style={styles.link}
        >
          GlobeView
        </Link>{' '}
        to retrieve a report for the correct destination port.
      </Text>
      <View style={styles.hr} />
    </View>
  );
}

DestinationDisclaimer.defaultProps = {
  portName: '',
  portUnlocode: '',
  aisDestination: null,
};

export default DestinationDisclaimer;
